import { render, staticRenderFns } from "./TextLanguagesDialog.vue?vue&type=template&id=a15d3844&scoped=true&lang=pug&"
import script from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TextLanguagesDialog.vue?vue&type=style&index=0&id=a15d3844&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15d3844",
  null
  
)

export default component.exports